export enum BiometricType {
  FACE, FINGER
}
